module.exports = __webpack_public_path__ + "img/crop_info_back_right.2c0e6d11.png";